(()=>{

  window.addEventListener('DOMContentLoaded',()=>{
    document.querySelectorAll('.section--bg-wide-spread').forEach((section, index) => {
      const bgArea = section.querySelector('.__bg-area');
      const bg = bgArea.querySelector('.bg');
      const bgImg = bg.querySelector('img');
      const desc = bgArea.querySelector('.__desc');
      const boxed = bgArea.querySelector('.__boxed');
      const render = (progress) => {
        const windowWidth = window.innerWidth;
        const boxedWidth = boxed.clientWidth;
        const diffWidth = (windowWidth - boxedWidth) * 1;


        const clipPath = `inset(0px ${diffWidth * (1-progress)}px 0px ${diffWidth * (1-progress)}px)`;
        if (bgImg) {
          gsap.set(bg, {
            clipPath: clipPath,
          })
        }
      };

      render(0);


      ScrollTrigger.create({
        trigger: bgArea,
        start: "top 90%",
        end: "center center",
        onUpdate: (self) => {
          const progress = self.progress;
          render(progress);
        },
        onEnter: (self) => {
          render(0);
        },
        onLeave: (self) => {
          render(1);
        },
        onEnterBack: (self) => {
          render(1);
        },
        onLeaveBack: (self) => {
          render(0);
        },
      });

      // ScrollTrigger.create({
      //   trigger: bgArea,
      //   start: "top bottom",
      //   end: "center center",
      //   onUpdate: (self) => {
      //     const progress = self.progress;
      //     // gsap.set(bgImg, {
      //     //   scale: 1.5 - progress * .5,
      //     // });
      //   },
      // });

      ScrollTrigger.create({
        trigger: bgArea,
        start: "top bottom",
        end: "bottom top",
        onUpdate: (self) => {
          const progress = self.progress;
          gsap.set(bgImg, {
            objectPosition: `50% ${100 - (progress * 100)}%`,
          });
        },
      });

      ScrollTrigger.create({
        trigger: bgArea,
        start: "top bottom",
        end: "bottom bottom",
        onUpdate: (self) => {
          const progress = self.progress;
          gsap.set(bgImg, {
            yPercent: ((1-progress) * -50),
          });
        },
      });

      ScrollTrigger.create({
        trigger: bgArea,
        start: "top top",
        end: "bottom top",
        onUpdate: (self) => {
          const progress = self.progress;
          gsap.set(bgImg, {
            yPercent: ((progress) * 50),
          });
        },
      });
    });
  });

})();